import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import { toast } from "react-toastify";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import constants from "../../../Constants";

const columns = [
  {
    name: "Nº Cobrança",
    selector: "sqCobranca",
    minWidth: "70px",
    center: true,
    sortable: true,
  },
  {
    name: "Ciclo",
    selector: "sqCiclo",
    minWidth: "250px",
    center: true,
    sortable: true,
  },
  {
    name: "Cobrança Atendida",
    selector: "fgCobrancaAtendida",
    minWidth: "250px",
    center: true,
    sortable: true,
  },
  {
    name: "Situação",
    selector: "stCobranca",
    minWidth: "80px",
    center: true,
    sortable: true,
  },
];

const useCobranca = (sqContribuinte, sqPessoa) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    const value = {
      SqContribuinte: sqContribuinte,
      SqPessoa: sqPessoa,
      pageSize,
      pageNumber,
    };

    request(apiRoutes.fiscalizacao.ordemservico.listaCobranca, value);
  }, [pageNumber, pageSize, request, sqContribuinte, sqPessoa]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data?.result.length > 0) {
      setRows(data?.result || []);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  const listaCobranca = (
    <div style={{ width: "100%" }}>
      <Row>
        <Col>
          <h5>Cobrança</h5>
          <DataTable
            noHeader
            keyField="SqCobranca"
            columns={columns}
            data={rows}
            progressPending={isLoading}
            noDataComponent="Não existem registros."
            progressComponent={<TextSpinner />}
            defaultSortFieldId={1}
            sortIcon={<BsArrowDown />}
            pagination
            paginationServer
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={constants.paginationComponentOptions}
            sortable
            pointerOnHover
            paginationPerPage={pageSize}
          />
        </Col>
      </Row>
    </div>
  );

  return { listaCobranca };
};

export default useCobranca;
